import { render, staticRenderFns } from "./LaravelVersion.vue?vue&type=template&id=63a82266&"
import script from "./LaravelVersion.vue?vue&type=script&lang=js&"
export * from "./LaravelVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports